import Axios from 'axios'

const instance = Axios.create({
  baseURL: process.env.API_ROOT || '/wp-json/wp/v2',
  responseType: 'json'
})

export default {
  install (Vue) {
    Object.defineProperty(Vue.prototype, '$http', { value: instance })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/http.js